import IWall from 'components/interfaces/IWall';

const getIndividualGlassTypes = (wall: IWall, glassIds: string[]) => {
  const individualGlassTypes: string[] = [];

  const isSpecialGlazyGlassType = () => {
    return wall.glazyDoubleGlassType === 'specialglazyglass';
  };

  const isGlazyDoublePositionFirst = () => {
    return wall.glazyDoubleSpecialPos === 'first';
  };

  const isGlazyDoublePositionSecond = () => {
    return wall.glazyDoubleSpecialPos === 'second';
  };

  const isGlazyDoublePositionLast = () => {
    return wall.glazyDoubleSpecialPos === 'last';
  };

  const getIndividualGlassType = (index: number) => {
    if (
      isSpecialGlazyGlassType() &&
      ((isGlazyDoublePositionFirst() && index === 0) ||
        (isGlazyDoublePositionSecond() && index === 1) ||
        (isGlazyDoublePositionLast() && index === glassIds.length - 1))
    ) {
      return 'specialglazyglass';
    }
    return 'glass';
  };

  glassIds.forEach((_, index) => {
    individualGlassTypes.push(getIndividualGlassType(index));
  });

  return individualGlassTypes;
};

export default getIndividualGlassTypes;
